/** When your routing table is too long, you can split it into small modules **/

const adminRouter = [
  // owner
  // {path: 'owner/board', component: () => import(/* webpackChunkName: "en9door_common" */'@/views/owner/o_board'), name: 'Owner Board', meta: {title: 'Owner Board'}},
]


export default adminRouter
